module.exports = __webpack_public_path__ + "img/1589512029.5b79db5b.jpg";